/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Irrigation_Runs_Load_ErrorInputs */

const vi_irrigation_runs_load_error = /** @type {(inputs: Irrigation_Runs_Load_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không tải được danh sách phiên tưới, vui lòng thử lại`)
};

/**

* @param {Irrigation_Runs_Load_ErrorInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const irrigation_runs_load_error = /** @type {((inputs?: Irrigation_Runs_Load_ErrorInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Irrigation_Runs_Load_ErrorInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_irrigation_runs_load_error(inputs)
});